import IconButton from "@/components/IconButton";
import { PhotoboothPerson } from "../queries";
import { CameraContent } from "@/features/photobooth";
import type { PhotoboothCaptureMethod } from "../_utils/amplitude";

interface CameraPageProps {
  person: PhotoboothPerson;
  onCapture: (imageData: string, captureMethod: PhotoboothCaptureMethod) => void;
  onClose: () => void;
}

export default function CameraPage({ person, onCapture, onClose }: CameraPageProps) {
  return (
    <div className="fixed inset-0 bg-sys-brand-surface z-50 flex flex-col" data-testid="camera-page">
      <div className="flex items-center justify-between p-4 border-b border-sys-brand-outline-variant bg-sys-brand-surface">
        <IconButton name="arrow_back" onClick={onClose} title="Back" />
        <div className="text-center">
          <h1 className="text-title-medium-bold font-serif text-sys-brand-on-surface">Take Photo</h1>
          <p className="text-label-small text-sys-brand-primary">
            {person.firstName} {person.lastName}
          </p>
        </div>
        <div className="w-10" />
      </div>

      <div className="flex-1 overflow-auto p-4 flex items-center justify-center">
        <div className="w-full max-w-2xl">
          <CameraContent onCapture={onCapture} onBack={onClose} />
        </div>
      </div>
    </div>
  );
}
